import {
    Utils,
} from '_pixiSrc/Utils';

let gameData;

// wrapper for working with localhost, which includes the validation of the data and is used to store the current state of the game

class GameData {
    static get data() {
        return gameData;
    }

    static getProperty(prop) {
        return gameData[prop];
    }

    static setProperty(prop, value) {
        gameData[prop] = value;

        return gameData[prop];
    }

    static load(callback) {
        if (!gameData) { GameData._init(); }

        const data = Object.assign({}, GameData.getInitiateData());

        GameData._validate(data, GameData.getDefaultData(), callback);
    }

    static save(callback) {
        if (!gameData) { GameData._init(); }
    }

    static _validate(data, defaultData, callback) {
        gameData = check(data, defaultData);
        callback();

        function check(data, defaultData) {
            data = data ? Utils.clone(data) : {};
            for (const i in defaultData) {
                if (defaultData.hasOwnProperty(i)) {
                    if (typeof defaultData[i] === 'object') {
                        if (Array.isArray(defaultData[i])) {
                            if (!Array.isArray(data[i]) || !data[i].length) { data[i] = defaultData[i]; }
                        } else { data[i] = check(data[i], defaultData[i]); }
                    } else if (!data[i]) { data[i] = defaultData[i]; }
                }
            }
            return data;
        }
    }

    // setting reset some values when loading the game, regardless of their previous state
    static getInitiateData() {
        return {
            demoPlay: true,
            freeGamePreStart: false,
            isTurboChecked: false,
            isAutospin: false,
            isFreeGame: false,
            isGambleGame: false,
            isExpandingOn: false,
            cheatMode: false,
            isPPOpen: false,
            isPPAllowed: true,
            isGambleActive: false,
            expandingSymbol: false,
            isGiftSpins: false,
            isPopupDialogueOpen: false,
            localization: 'en',
            musicEnabled: true,
            soundEnabled: true,
            isAutoTurboChecked: false,
            isLeftHand: false,
        };
    }

    static getDefaultData() {
        return {
            demoPlay: true,
            freeGamePreStart: false,
            isSoundEnabled: true,
            isMusicEnabled: true,
            coins: 10000,
            isTurboChecked: false,
            isAutospin: false,
            isFreeGame: false,
            isGambleGame: false,
            expandingSymbol: false,
            cheatMode: false,
            isPPOpen: false,
            isPPAllowed: true,
            isGambleActive: false,
            isGiftSpins: false,
            isPopupDialogueOpen: false,
            localization: 'en',
            musicEnabled: true,
            soundEnabled: true,
            isAutoTurboChecked: false,
            isLeftHand: false,
        };
    }

    static _init() {
        gameData = {};
    }
}

export default GameData;
